// extracted by mini-css-extract-plugin
module.exports = {"externalIcons":"Navigation_externalIcons__2YxVa"};